import { Button } from "@narmi/design_system";
import { catcat as cc, FormHeaderWithIcon } from "cerulean";
import { useLocalization } from "@fluent/react";
import ComboAccountSelector from "../ComboAccountSelector";
import styles from "./DirectDepositLandingPage.module.scss";
import DirectDepositSSO from "./DirectDepositSSO";
import {
  useDirectDepositContainer,
  useDirectDepositFeatureStatus,
  useDirectDepositManual,
} from "./DirectDepositContainer";
import DirectDepositManualForm from "./DirectDepositManualForm";
import RoutingAndAccountNumberCard from "./RoutingAndAccountNumberCard";

const DirectDepositLandingPage = () => {
  const { l10n } = useLocalization();
  const {
    isSSOTokenLoading,
    pinwheelEventHandlers,
    ssoToggleModalHandler,
    isManualFormOpen,
    manualToggleFormHandler,
  } = useDirectDepositContainer();
  const { accountFieldFormProps, eligibleAccounts, selectedAccount } =
    useDirectDepositManual();
  const { ssoProvider } = useDirectDepositFeatureStatus();

  return (
    <div className={styles.directDepositPage}>
      <FormHeaderWithIcon
        headerText={l10n.getString(
          "direct-deposit-landing-title",
          {},
          "Set up direct deposit"
        )}
      />
      {ssoProvider !== "none" && (
        <div className={styles.card}>
          <div className="fontWeight--bold fontColor--heading margin--bottom--xs">
            {l10n.getString(
              "direct-deposit-sso-setup-title",
              {},
              "We’ll do it for you"
            )}
          </div>
          <div className="fontSize--s fontColor--secondary margin--bottom--l">
            {l10n.getString(
              "direct-deposit-sso-information",
              {},
              "Start by finding your employer, payroll provider, or unemployment agency. Search from thousands of providers."
            )}
          </div>
          <Button
            isLoading={isSSOTokenLoading}
            kind="primary"
            label={l10n.getString(
              "direct-deposit-sso-find-provider-button",
              {},
              "Find your provider"
            )}
            testId="find-direct-deposit-provider"
            size="m"
            onClick={ssoToggleModalHandler}
          />
        </div>
      )}
      <div className={styles.card}>
        <div className="fontWeight--bold fontColor--heading margin--bottom--xs">
          {l10n.getString(
            "direct-deposit-manual-setup-title",
            {},
            "I'll do it myself"
          )}
        </div>
        <div className="fontSize--s fontColor--secondary">
          {l10n.getString(
            "direct-deposit-manual-information",
            {},
            "Select the account you wish to deposit into and get a direct deposit form to take to your employer."
          )}
        </div>
        <div className="margin--top--xl">
          <ComboAccountSelector
            isDestination
            label={l10n.getString(
              "direct-deposit-account-drawer-title",
              {},
              "Account"
            )}
            showAddExternalAccountLink={false}
            accounts={eligibleAccounts}
            {...accountFieldFormProps}
          />
        </div>
        <div
          className={cc({
            "margin--top--l": !!selectedAccount,
            "margin--bottom--xl": !!selectedAccount,
            "margin--bottom--l": !selectedAccount,
          })}
        >
          <RoutingAndAccountNumberCard selectedAccount={selectedAccount} />
        </div>
        <Button
          kind="secondary"
          label={l10n.getString(
            "direct-deposit-manual-form-button",
            {},
            "Fill out direct deposit form"
          )}
          testId="open-manual-direct-deposit-form"
          size="m"
          onClick={manualToggleFormHandler}
        />
      </div>
      <DirectDepositSSO type={ssoProvider} {...pinwheelEventHandlers} />
      <DirectDepositManualForm
        isOpen={isManualFormOpen}
        onUserDismiss={manualToggleFormHandler}
      />
    </div>
  );
};

export default DirectDepositLandingPage;
